import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useAppIdRouteParamListener } from "../../hook/app";
import { useFetchNotebook, useNotebookPagePath } from "../../hook/page";
import { selectRootNotebookPages } from "../../selectors/page";
import { NoteBlockContainer, NotePageContainer } from "../note";
import Refresh from "@mui/icons-material/Refresh";
import {
  IconButton,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { CasLoader } from "../brand/CasLoader";

const RefreshNotebookButton: React.FC = () => {
  const fetchNotebook = useFetchNotebook();
  const [loading, setLoading] = useState(false);
  return loading ? (
    <CasLoader size={18} />
  ) : (
    <IconButton
      size="small"
      onClick={() => {
        setLoading(true);
        fetchNotebook().finally(() => setLoading(false));
      }}
    >
      <Refresh fontSize="small" />
    </IconButton>
  );
};

export const NotebookRootPage: React.FC = () => {
  useAppIdRouteParamListener();
  const pages = useSelector(selectRootNotebookPages);
  const notebookPagePath = useNotebookPagePath();

  return (
    <NotePageContainer pageName="Notebook">
      <NoteBlockContainer name="Pages" toolbar={<RefreshNotebookButton />}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Id</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pages.map((page) => {
              const pageData = page["page-data"];
              const pageName = pageData.name;
              const pageId = page["page-id"];

              return (
                <TableRow key={pageId}>
                  <TableCell>{pageName}</TableCell>
                  <TableCell>
                    <Link href={notebookPagePath({ pageId })}>{pageId}</Link>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </NoteBlockContainer>
    </NotePageContainer>
  );
};
